import { PREDEFINED_SWATCH_COLORS } from './../../../../../plugin-button/defaults';

export const removeColorDuplicates = (themeColorsProp: string[], customColorsProp: string[]) => {
  const ignoredCustomColors = [...PREDEFINED_SWATCH_COLORS, ...themeColorsProp];

  const adjustedCustomColors = customColorsProp.filter(
    color => !ignoredCustomColors.includes(color)
  );

  return {
    themeColors: themeColorsProp,
    customColors: adjustedCustomColors,
  };
};
